<template>
  <div class="flex flex-column mr-5">
    <h1>{{ title }}</h1>
    <p class="text-sm font-light">
      {{ description }}
    </p>
  </div>
</template>
<script lang="ts" setup>
  defineProps<{
    title: string
    description: string
  }>()
</script>
